<template>
  <div class="settlement">
    <el-button type="primary" :disabled="!isShowSettlement" @click="onOpenDialog">发起结佣</el-button>
    <el-dialog title="发起结佣" width="70%" :visible.sync="dialogVisible" modal-append-to-body append-to-body
      class="settlement">
      <el-form ref="form" label-width="100px" :model="form" :rules="rules">
        <el-form-item label="结佣周期：" prop="time">
          <el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" />
        </el-form-item>
        <el-form-item label="结佣方式" prop="settleType">
          <el-radio-group v-model="form.settleType">
            <el-radio :label="0">常规结佣</el-radio>
            <!-- <el-radio :label="1">特殊结佣</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <!-- 当结佣方式为特殊结佣 -->
        <el-form-item v-if="form.settleType === 1" label="结佣比例" prop="settleRatio">
          <el-input v-model="form.settleRatio" class="settlement-ratio" placeholder="0~15">
            <template slot="append">%</template></el-input>
          <div class="settlement-tip">
            本次结佣佣金将按左侧设置的比例进行计算，结佣金额 = 待结佣订单金额 x
            结佣比例。(仅本次结佣生效，不影响其他地方佣金计算)
          </div>
        </el-form-item>
        <el-form-item label="结佣代理" prop="isSettleAllUser">
          <el-radio-group v-model="form.isSettleAllUser" @change="changeSettleAllUser">
            <el-radio :label="1">所有代理
              <span class="settlement-tip__red">(所有达人关联的代理)</span></el-radio>
            <span @click.prevent="changeSettleAllUser(0, 'user')">
              <el-radio :label="0">部分代理</el-radio>
            </span>
          </el-radio-group>
        </el-form-item>
        <!-- 当结佣代理是部分代理 -->
        <div v-if="form.isSettleAllUser === 0 && form.userUUID && form.userUUID.length
          " class="settlement-userUUId">
          <el-tag v-for="(item, index) in form.userUUID" :key="index" closable class="tag" color="tag" type="info"
            :disable-transitions="true" @close="onMoveUserUUId(item, index)">
            {{ item.nickname }}</el-tag>
        </div>
      </el-form>
      <!-- 计算表格 -->
      <div class="settlement-computed">
        <el-button :loading="computedLoading" type="primary" @click="onComputed">查询并计算</el-button>

        <!-- 查询结果 -->
        <template v-if="table.total > 0">
          <span class="settlement-tip__red">下方列表不包含已结佣过的数据。</span>
          <el-table ref="table" v-loading="table.loading" :data="table.dataSource" border row-key="id" height="300"
            class="settlement-computed__table">
            <el-table-column prop="nickname" label="代理昵称" align="center" />
            <el-table-column prop="referenceNum" label="本次结佣达人数" align="center" />

            <el-table-column prop="refundAmount" align="center">
              <template slot="header">
                <span class="settlement-tip__weight settlement-tip__black">待结佣订单</span>
              </template>
              <template slot-scope="scope">
                <span class="settlement-tip__weight settlement-tip__black">{{ scope.row.settledCntTotal }}({{
                  scope.row.settledAmountTotal
                }}元)</span>
              </template>
            </el-table-column>

            <el-table-column prop="settleRatio" label="结佣方式" align="center">
              <template slot-scope="scope">
                {{ scope.row.settleType === 1 ? '特殊结佣' : '常规结佣' }}
                <span v-if="scope.row.settleType === 1">{{ scope.row.settleRatio }}%</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" align="center" min-width="120px">
              <template slot="header">
                <span class="settlement-tip__weight settlement-tip__red">应结佣金额（元）</span>
              </template>
              <template slot-scope="scope">
                <div class="settlement-tip__weight settlement-tip__red">{{
                  scope.row.settledCommissionTotal
                }}</div>

                <div> (已含销售溢价：<span
                    :style="{ color: scope.row.settledPremiumTotal > 0 ? 'green' : scope.row.settledPremiumTotal === 0 ? 'black' : 'red' }">
                    <template v-if="scope.row.settledPremiumTotal">
                      {{
                        scope.row.settledPremiumTotal > 0 ? '+' : '-'
                      }}</template>
                    {{ scope.row.settledPremiumTotal }}元
                  </span>)

                </div>

              </template>
            </el-table-column>
            <el-table-column prop="compensation" align="center">
              <template slot="header">
                <span class="settlement-tip__weight settlement-tip__red">补差（元）</span>
              </template>
              <template slot-scope="scope">
                <!-- 补差 -->
                <compensation-pop :row="scope.row" @setTable="setTable" />
              </template>
            </el-table-column>
            <el-table-column prop="address" align="center">
              <template slot="header">
                <span class="settlement-tip__weight settlement-tip__red">补差后应结佣金额（元）</span>
              </template>
              <template slot-scope="scope">
                <span class="settlement-tip__weight settlement-tip__red">{{
                  scope.row.settledCommissionNum
                }}</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页-->
          <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
            @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
            :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
          <div class="settlement-tip__red settlement-allCommission">
            本次总结佣金额：{{ allCommission }}元
          </div>
        </template>
      </div>

      <span slot="footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit">提交结佣</el-button>
      </span>
    </el-dialog>
    <!-- 部分代理选择 -->
    <partial-agency v-if="partialAgencyVisible" ref="partial" v-model="partialAgencyVisible" :user-u-u-i-d="form.userUUID"
      @selectPartial="selectPartial" @close="partialAgencyVisible = false" />
    <!-- 结佣二次确认 -->
    <submit-verify v-model="verifyVisible" :form="form" :fill-commission="fillCommission" :all-commission="allCommission"
      @successSubmit="successSubmit" />
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();
import partialAgency from './PartialAgency'
import submitVerify from './SubmitVerify'
import compensationPop from './CompensationPop'
import { matchFractionalPart1 } from '@/utils/regExp'
const formParams = {
  time: [], // 结佣周期
  settleType: 0, // 结佣方式
  settleRatio: '', // 结佣比例
  isSettleAllUser: 1, // 结佣代理
  userUUID: [] // 代理ID集合
}
export default {
  components: {
    partialAgency, // 部分代理
    submitVerify, // 二次确认
    compensationPop // 补差价pop
  },
  props: {
    isShowSettlement: {
      // 是否可以结佣
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fillCommission: {}, // 补差的对象
      computedList: [], // 计算的数据
      table: {
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false // 表格加载loading
      },
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1 // 表格当前页数
      },
      verifyVisible: false, // 结佣二次确
      partialAgencyVisible: false, // 部分代理显示
      pickerOptions: {
        // 时间设置选项
        disabledDate(time) {
          const curDate = new Date().getTime()
          const minTime = curDate - 90 * 24 * 3600 * 1000 // 90天
          const maxTime = curDate - 1 * 24 * 3600 * 1000 // 昨天
          return time.getTime() > maxTime || time.getTime() < minTime
        }
      },
      form: Object.assign({}, formParams), // 表单
      computedLoading: false, // 计算按钮loading
      dialogVisible: false, // 显示弹框
      rules: {
        time: [{ required: true, message: '请选择结佣周期', trigger: 'blur' }],
        settleType: [
          { required: true, message: '请选择结佣方式', trigger: 'blur' }
        ],
        settleRatio: [
          { required: true, message: '请输入结佣比例', trigger: 'blur' },
          {
            required: true,
            pattern: matchFractionalPart1,
            message: '请输入数字，最多保留一小数 ',
            trigger: ['blur', 'change']
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value > 15) {
                callback(new Error(`请输入小于15的数字`))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        isSettleAllUser: [
          {
            required: true,
            message: '请选择结佣代理',
            trigger: ['blur', 'change']
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.isSettleAllUser !== 0) {
                return callback()
              }
              this.form.userUUID && this.form.userUUID.length
                ? callback()
                : callback('请至少选择一个部分代理')
            }
          }
        ]
      }
    }
  },
  computed: {
    allCommission() {
      // 总金额
      let settledCommissionNum = '0'
      this.computedList.forEach((item) => {
        settledCommissionNum = this.calculate(
          settledCommissionNum,
          item.settledCommissionNum
        )
      })
      return settledCommissionNum
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler: async function () {
        // 重置数据
        this.computedList = []
        this.table = {
          dataSource: [],
          total: 0,
          loading: false
        }
        this.pagination = {
          pageSize: 10,
          pageNo: 1
        }
      }
    }
  },
  methods: {
    // 相加 add    相减 minus
    calculate(a, b, way = 'add', precision = 2) {
      const p = Math.pow(10, precision)
      const result = way === 'add' ? (a * p + b * p) / p : (a * p - b * p) / p
      return result.toFixed(precision)
    },

    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 设置表格
    setTable({ id, compensationNum, compensationType }) {
      console.log('更新数据')
      // 更新计算数据
      this.computedList.forEach((item) => {
        if (item.id === id) {
          item.compensationNum = compensationNum
          item.compensationType = compensationType
          item.compensationNumStr =
            item.compensationType === 1
              ? `+${item.compensationNum}`
              : `-${item.compensationNum}`
          item.settledCommissionNum =
            compensationType === 1 //  // 1是补 2是扣
              ? this.calculate(
                item.settledCommissionTotal,
                item.compensationNum
              )
              : this.calculate(
                item.settledCommissionTotal,
                item.compensationNum,
                'minus'
              )
        }
      })
      // 更新传递给后端的数据
      const obj = {}
      this.computedList.forEach((item) => {
        // 有值代表修改过
        if (item.compensationType) {
          obj[item.userUUID] = item.compensationNumStr
        }
      })
      this.fillCommission = obj

      // 改完以后刷新列表
      this.freshTable()
    },
    // 计算表格数据
    freshTable() {
      this.table.loading = true
      this.table.dataSource = this.computedList.slice(
        (this.pagination.pageNo - 1) * this.pagination.pageSize,
        this.pagination.pageNo * this.pagination.pageSize
      )
      this.table.total = this.computedList.length
      this.table.loading = false
    },
    // 打开弹框
    onOpenDialog() {
      this.dialogVisible = true
    },
    // 取消
    onCancel() {
      // 重置数据
      this.computedList = []
      this.table = {
        dataSource: [],
        total: 0,
        loading: false
      }
      this.pagination = {
        pageSize: 10,
        pageNo: 1
      }
      this.form = Object.assign({}, formParams)
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    // 计算
    async onComputed() {
      this.computedLoading = true
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            startDate: this.form.time && this.form.time.length ? this.form.time[0] : '',
            endDate: this.form.time && this.form.time.length ? this.form.time[1] : '',
            settleType: this.form.settleType,
            isSettleAllUser: this.form.isSettleAllUser,
            miniAppType:5
          }

          // 特殊结佣
          if (params.settleType === 1) {
            params.settleRatio = this.form.settleRatio
          }
          // 部分代理
          if (params.isSettleAllUser === 0) {
            params.userUUIDStr = this.form.userUUID
              .map((item) => item.userUUID)
              .join(',')
          }

          const data = await DouYinModel.settlementSearch(params).finally(() => {
            this.computedLoading = false
          })
          if (data.data.code === 200) {

            data.data.data && data.data.data.length
              ? this.$message.success('查询成功')
              : this.$message.warning('查询结果为空')
            this.computedList = data.data.data.map((item, index) => ({
              ...item,
              compensationNumStr: '', // 金额中文
              compensationNum: '', // 金额
              compensationType: '', // 1 是正数 2是负数
              settledCommissionNum: item.settledCommissionTotal // 最终补差价金额
            }))

            this.freshTable()
          } else {
            this.$message.error(data.data.message || data.data.info)
          }
        } else {
          this.computedLoading = false

        }
      })
    },
    // 移除
    onMoveUserUUId(item, index) {
      this.form.userUUID.splice(index, 1)
    },
    // 选中部分代理
    selectPartial(value) {
      // 如果有选择的代理就清空验证
      if (value && value.length) {
        this.$refs.form.clearValidate('isSettleAllUser')
      }
      this.form.userUUID = value
    },
    // 修改代理方式
    changeSettleAllUser(value, type) {
      // 用户主动点击
      if (type === 'user') {
        this.form.isSettleAllUser = value
      }
      this.partialAgencyVisible = Boolean(!this.form.isSettleAllUser)
    },
    // 提交结佣
    onSubmit() {
      if (this.computedList && this.computedList.length) {
        this.verifyVisible = true
      } else {
        this.$message.error('请先查询并计算佣金')
      }
    },
    // 结佣成功
    successSubmit() {
      this.onCancel()
      this.$emit('refresh')
    }
  }
}
</script>
<style lang="less" scoped>
.settlement {
  &-computed {
    padding: 0 20px;

    &>span {
      margin-left: 10px;
    }

    &__table {
      margin-top: 20px;
    }
  }

  &-allCommission {
    padding: 10px 20px 0 20px;
    text-align: right;
  }

  &-tip {
    color: #999;

    &__red {
      color: red;
    }

    &__black {
      color: #333;
    }

    &__weight {
      font-weight: bold;
    }
  }

  &-ratio {
    width: 30%;
  }

  &-userUUId {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 10px 0 10px;
    margin: 0 20px;
    border: 1px dashed #dcdfe6;
    border-radius: 2px;
    margin-bottom: 20px;
    max-height: 200px;
    overflow-y: auto;

    &>.el-tag {
      margin: 0 10px 10px 0px;
    }
  }

  /deep/.el-dialog {
    margin-top: 8vh !important;

    &__body {
      overflow-y: auto;
      max-height: 70vh;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/userData/SetSettlement.vue